const webLinkMap = new Map();

webLinkMap.set('F', 'Facebook');
webLinkMap.set('L', 'Linked In');
webLinkMap.set('T', 'Twitter');
webLinkMap.set('I', 'Instagram');
webLinkMap.set('W', 'Website');

export default webLinkMap;